<template>
  <div class="mod-config">
    <div class="boxpoi" style="height: 100%;">
      <p class="toplist">
        <span style="font-size: 20px;">点位信息</span>
      </p>
      <!-- 模板一 -->
      <div class="userMuban">
        <el-form :model="dataForm" ref="dataForm">
          <el-table :data="tableData">
            <el-table-column label="新增数量" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.number"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="点位名称前缀" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.namePrefix"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="所属企业" align="center">
              <template slot-scope="scope">
                <el-select v-model="scope.row.companyId" filterable placeholder="请选择企业" style="width: 100%">
                  <el-option v-for="item in companyOption" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="国家" align="center">
              <template slot-scope="scope">
                <el-select v-model="scope.row.countryId" @change="getProvinceOption" placeholder="请选择国家"
                  style="width: 100%">
                  <el-option v-for="item in countryOption" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="省份" align="center">
              <template slot-scope="scope">
                <el-select v-model="scope.row.provinceId" @change="getCityOption" placeholder="请选择省份"
                  style="width: 100%">
                  <el-option v-for="item in provinceOption" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="城市" align="center">
              <template slot-scope="scope">
                <el-select v-model="scope.row.cityId" @change="getDistrictOption" placeholder="请选择城市"
                  style="width: 100%">
                  <el-option v-for="item in cityOption" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="区域" align="center">
              <template slot-scope="scope">
                <el-select v-model="scope.row.districtId" @change="getStreetOption" placeholder="请选择区域"
                  style="width: 100%">
                  <el-option v-for="item in districtOption" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="街道" align="center">
              <template slot-scope="scope">
                <el-select v-model="scope.row.streetId" placeholder="请选择街道" style="width: 100%">
                  <el-option v-for="item in streetOption" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table>
          <el-table :data="tableData">
            <el-table-column label="地址" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.address" id="searchPoint"></el-input>
                <input type="button" value="搜索" @click="search()"
                  style=" position: absolute;right: 12px;height: 40px;width: 50px;cursor: pointer;" />
              </template>
            </el-table-column>
            <el-table-column label="经度" align="center" width="207">
              <template slot-scope="scope">
                <el-input v-model="scope.row.longitude"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="纬度" align="center" width="207">
              <template slot-scope="scope">
                <el-input v-model="scope.row.latitude"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </el-form>

      </div>
      <p style="display: none;">{{ dizhi }}</p>
      <!-- 地图 -->
      <div style="height: calc(100% - 350px);" id="mapTD">

      </div>
    </div>
    <span slot="footer" class="dialog-footeruser">
      <el-button type="primary" @click="saveGet">确定</el-button>
      &nbsp;&nbsp;
      <router-link to="/indexhome/poi" replace>
        <el-button type="danger">取消</el-button>
      </router-link>
    </span>
  </div>
</template>

<script>
var map, marker;
var geocoder;
export default {
  name: 'batchAddition',
  data() {
    return {
      dataForm: {

      },
      tableData: [{
        namePrefix: "",
        number: "",
        companyId: "",
        countryId: "",
        provinceId: "",
        cityId: "",
        districtId: "",
        streetId: "",
        address: "",
        longitude: "",
        latitude: ""
      }],
      companyOption: [],
      countryOption: [],
      provinceOption: [],
      cityOption: [],
      districtOption: [],
      streetOption: [],
      dizhi: ""
    }
  },
  created() {
    this.getCompanyOption()
    this.getCountryOption()
    this.getMapp()
  },
  methods: {
    searchResult(result) {
      this.dizhi = result.location.lon;
      if (result.getStatus() == 0) {
        this.tableData[0].address = result.formatted_address;
        this.tableData[0].longitude = result.location.lon;
        this.tableData[0].latitude = result.location.lat;
        map.panTo(result.getLocationPoint(), 16);
        //创建标注对象
        marker = new T.Marker(result.getLocationPoint());
        //向地图上添加标注
        map.addOverLay(marker);
      } else {
        alert(result.getMsg());
      }
    },
    searchResulted(result) {
      this.dizhi = result.location.lon;
      if (result.getStatus() == 0) {
        console.log(result);
        this.tableData[0].longitude = result.location.lon;
        this.tableData[0].latitude = result.location.lat;
        map.panTo(result.getLocationPoint(), 16);
        //创建标注对象
        marker = new T.Marker(result.getLocationPoint());
        //向地图上添加标注
        map.addOverLay(marker);
      } else {
        alert(result.getMsg());
      }
    },
    getMapp() {
      this.$http({
        url: this.$http.adornUrl("poi/list"),
        method: "get",
      }).then(({ data }) => {
        let _this = this;
        map = new T.Map("mapTD")
        //设置显示地图的中心点和级别
        map.centerAndZoom(new T.LngLat(105.953743, 28.50441), 12)
        //允许鼠标双击放大地图
        map.enableScrollWheelZoom();
        //创建对象
        geocoder = new T.Geocoder();
        map.addEventListener("click", function (e) {
          map.clearOverLays();
          geocoder.getLocation(e.lnglat, _this.searchResult);
          marker = new T.Marker(new T.LngLat(e.lnglat.lng, e.lnglat.lat));
          //创建标注对象
          map.addOverLay(marker);
        });
      });
    },
    search() {
      map.clearOverLays();
      geocoder.getPoint(this.tableData[0].address, this.searchResulted);
    },
    //获取企业option
    getCompanyOption() {
      this.$http({
        url: this.$http.adornUrl("/company/option"),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.companyOption = data.data.companyOption
        }
      })
    },
    //获取国家option
    getCountryOption() {
      this.$http({
        url: this.$http.adornUrl("/area/option/0"),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.countryOption = data.data.areaOption
        }
      })
    },
    //获取省份
    getProvinceOption(selectValue) {
      this.$http({
        url: this.$http.adornUrl("/area/option/" + selectValue),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.provinceOption = data.data.areaOption
        }
      })
    },
    //获取城市
    getCityOption(selectValue) {
      this.$http({
        url: this.$http.adornUrl("/area/option/" + selectValue),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.cityOption = data.data.areaOption
        }
      })
    },
    //获取区域
    getDistrictOption(selectValue) {
      this.$http({
        url: this.$http.adornUrl("/area/option/" + selectValue),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.districtOption = data.data.areaOption
        }
      })
    },
    //获取街道
    getStreetOption(selectValue) {
      this.$http({
        url: this.$http.adornUrl("/area/option/" + selectValue),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.streetOption = data.data.areaOption
        }
      })
    },
    saveGet() {
      this.$http({
        url: this.$http.adornUrl('poi/saveBatch'),
        method: 'post',
        data: this.$http.adornData({
          "namePrefix": this.tableData[0].namePrefix,//点位名称
          "number": this.tableData[0].number,     //新增数量
          "companyId": this.tableData[0].companyId,  //企业id
          "countryId": this.tableData[0].countryId,  //国家id
          "provinceId": this.tableData[0].provinceId, //省份id
          "cityId": this.tableData[0].cityId,     //城市id
          "districtId": this.tableData[0].districtId,  //区域id
          "streetId": this.tableData[0].streetId,    //街道id
          "address": this.tableData[0].address,  //地址
          "longitude": this.tableData[0].longitude,  //经度
          "latitude": this.tableData[0].latitude    //纬度
        })
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.$message({
            message: data.msg,
            type: 'success',
            duration: 1000,
          })
          this.$router.replace({ path: '/indexhome/poi' });
        } else {
          this.$message.error(data.msg);
        }
      })
    }
  }
}
</script>

<style>
.boxpoi .toplist {
  height: 50px;
  line-height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #bbb;
}

.mod-config {
  position: relative;
}

.dialog-footeruser {
  display: flex;
  bottom: 0px;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  border-top: 2px solid #bbb;
  height: 60px;
}

.userMuban {
  margin-top: 10px;
  height: 226px;
}

.boxpoi .userMuban .el-table td,
.boxpoi .userMuban .el-table th.is-leaf {
  border-right: none !important
}
</style>


// WEBPACK FOOTER //
// src/pages/admincenter/batchAdd/poiIndex.vue